

















































import {
  computed, defineComponent, reactive, ref,
} from '@vue/composition-api';
import { useQuery } from '@vue/apollo-composable';

import useAuth from '@/useAuth';
import {
  NOW_START_YEAR,
  NOW,
} from '@/utils';

import TreemapArea from '@/components/Report/01-Income/TreemapArea.vue';
import TreemapAreaWithoutAutoFiltered from '@/components/Report/01-Income/TreemapAreaWithoutAutoFiltered.vue';
import CommonHubSelector from '@/components/CommonHubSelector.vue';

import getHubs from '@/gql/company/getHubs.gql';
import incomeByArea from '@/gql/managementReport/01-Income/incomeByArea.gql';

const DeliveryIncomeByArea = defineComponent({
  components: {
    TreemapArea,
    CommonHubSelector,
    TreemapAreaWithoutAutoFiltered,
  },
  setup() {
    const { me } = useAuth();
    const filter = reactive({
      hub: null,
      monthRange: {
        from: NOW_START_YEAR,
        to: NOW,
      },
    });

    const { result, loading } = useQuery(
      getHubs,
      { first: 100, page: 1 },
      () => ({
        fetchPolicy: 'network-only',
      }),
    );
    const hubArray = computed(() => {
      if (loading.value === false && result.value) {
        return result.value.me.company.hubs.data;
      }
      return ([]);
    });

    return {
      me,
      incomeByArea,
      filter,
      hubArray,
    };
  },
});

export default DeliveryIncomeByArea;
